export class GenericConfirmationDialogModel {
    public title: string;
    public messages: string[] = [];
    public cancel: string;
    public confirm: string;
    public onConfirm:() => void;
    public onCancel?:() => void;
    public icon?: string;
    public iconColor?: string;
    public dialogKey?: string = 'default';
}